import React from "react";
import { defaultStyle } from "./style";
import { css } from "emotion";
import { Alert as AtomicAlert } from "@maxmilhas/hangar-components-atomic/public";

const Alert = props => {
	const hasIcon = props.icon && props.type !== "outline";
	const alertStyles = defaultStyle(props.type, hasIcon);
	return (
		<div
			className={css`
				${alertStyles}
			`}
		>
			<AtomicAlert {...props} />
		</div>
	);
};

export default Alert;
